/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRateAggregationTrendRequest extends models.BillingAggregationBase {
    getFixupPrototypeFunction() { return BillingRateAggregationTrendRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingRateAggregationTrendRequest>): BillingRateAggregationTrendRequest {
        let obj = Object.assign(new BillingRateAggregationTrendRequest(), model);
        BillingRateAggregationTrendRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRateAggregationTrendRequest>): BillingRateAggregationTrendRequest {
        if (!model) return null;
        return BillingRateAggregationTrendRequest.newInstance(<BillingRateAggregationTrendRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRateAggregationTrendRequest) {
        if (!obj) return;

        models.BillingRateAggregationTrendRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRateAggregationTrendRequest): boolean {
        if (models.BillingAggregationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRateAggregationTrendRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.group_by) {
            for (let val of this.group_by) {
                models.BillingGroupByDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Billing plan to select data from
     */
    billing_source: string;

    /**
     * If set, group results by the given group of fields
     */
    group_by: Array<models.BillingGroupByDetails>;

}
